<template>
    <div>
        <!--middle middle section-->
        <div class="main-internal-section width-full float-l">
            <div class="container">
                <template v-if="cantAccessPage === true">
                    <div class="row">

                        <div class="chat-btm-section-main width-full float-l">
                            <!-- middle section -->
                            <div class="chat-web-section chat-user-list-main float-l width-full">
                                <h2 class="chat-page-title float-l colpie-80 color-333333 heading-text-24 line-height-28 font-bold ucase"> Users </h2>
                                <div class="logout-btn float-r">
                                    <!-- <button type="submit" class="btn btn-primary internal-large-btn">
                                        <span class="gradient"></span> Add User
                                    </button> -->

                                    <!-- <router-link class="btn btn-primary internal-large-btn" v-bind:to="{name: 'UserCreate'}">
                                        <span class="gradient"></span> Add User
                                    </router-link> -->
                                </div>

                                <!-- <div class="user-listing-section-web float-l width-full"> -->
                                    <vue-good-table
                                            ref="listUserList"
                                            mode="remote"
                                            title="User"
                                            @on-page-change="onPageChange"
                                            @on-selected-rows-change="selectionChanged"
                                            @on-column-filter="onColumnFilter"
                                            @on-per-page-change="onPerPageChange"
                                            @on-sort-change="onSortChange"
                                            :totalRows="totalRecords"
                                            :columns="columns"
                                            :rows="rows"
                                            :pagination-options="{
                                                enabled: true,
                                                position: 'bottom',
                                                perPage: 10,
                                                dropdownAllowAll: false,
                                            }"
                                            :select-options="{
                                        enabled: true,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'Clear',
                                        }"
                                            :search-options="{
                                        enabled: false,
                                        }">
                                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                            <div :key="key" class="user-list-view">
                                                <div v-if="props.column.field == 'action'">
                                                    <router-link title="Edit User" v-bind:to="{name: 'UserEdit', params:{id: props.row.id}}"><i class="fa fa-angle-right"></i></router-link>
                                                </div>
                                                <div v-if="props.column.field == 'sectionRoleHtml'" class='btn-center-vvg'>
                                                    <span v-html="props.formattedRow[props.column.field]"></span>
                                                </div>
                                                <div v-else>
                                                    {{props.formattedRow[props.column.field]}}
                                                </div>
                                            </div>
                                        </template>

                                        <div slot="selected-row-actions">
                                            <template>
                                                <button id="deleteGroupBtn" v-on:click.prevent="activeOrInactiveState('De Activate')" class="btn btn-success waves-effect row-deactivate-btn">De Activate</button>
                                                <button id="deleteGroupBtn" v-on:click.prevent="activeOrInactiveState('Activate')" class="btn btn-success waves-effect row-activate-btn">Activate</button>
                                            </template>
                                        </div>

                                    </vue-good-table>
                                <!-- </div> -->
                            </div>
                            <div class="user-list-mobile float-l width-full">
                                <!-- <div class="large-btn float-l width-full">
                                    <router-link  v-bind:to="{name: 'UserCreate'}">
                                        Add User
                                    </router-link>
                                </div> -->
                                <div class="mobile-class-userlist">
                                    <div class="mobile-active-deactive-button vgt-selection-info-row__actions vgt-pull-right" v-if="!mobileButtonHideShow">
                                        <button id="deleteGroupBtn" v-on:click.prevent="activeOrInactiveState('De Activate')" class="btn btn-success waves-effect row-deactivate-btn">De Activate</button>
                                        <button id="deleteGroupBtn" v-on:click.prevent="activeOrInactiveState('Activate')" class="btn btn-success waves-effect row-activate-btn">Activate</button>
                                    </div>
                                    <template v-if="userArray && userArray.length > 0">
                                        <div class="user-list-section col-12 float-l relative pt_20 pb_20" v-for="(user, userIndex) in userArray">
                                            <div :key="userIndex" class="custom-control custom-checkbox mb_3">
                                                <!-- <input type="checkbox" class="custom-control-input" id="customCheck" name="example1"> -->
                                                <label class="custom-control-label float-l width-full heading-text-16 line-height-20 color-333333 font-benton-medium pl_15" for="customCheck">
                                                    <input type="checkbox" :id="'customCheck'+user.id" :value="user.id" v-model="userCheckbox">
                                                    <div class="user-name-mobile">
                                                        {{user.name | filterUSting}}
                                                        <span class="color-888888 float-l width-full font-text-regular-benton heading-text-13 line-height-17 pt_3">
                                                            {{user.email}}
                                                        </span>
                                                    </div>
                                                </label> 
                                                <router-link title="Edit User" v-bind:to="{name: 'UserEdit', params:{id: user.id}}"><i class="fa fa-angle-right"></i></router-link>               
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <!-- middle section -->
                    </div>
                </template>
                <template v-else>
                    <template v-if="isRequestComplete">
                        <div class="col-md-12">
                            <div class="error-template">
                                <h1>
                                    Oops!</h1>
                                <h2>
                                    403 </h2>
                                <div class="error-details">
                                    Sorry!, You don't have permission to access this page.
                                </div>
                            </div>
                        </div>
                    </template>
                </template>
            </div> 
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import Vue from "vue";
    import Footer from "@/components/partials/Footer";
    import {HTTP} from '../../http-common';
    import {commonMixins} from '../../mixins/commonMixins';
    import moment from 'moment';
    import EventBus from '../event-bus';
    var contex;
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    Vue.use(VueGoodTable);

    Vue.component("app-footer", Footer);
    export default {
        name: 'UserList',
        mixins: [commonMixins],
        data () {
            return {
                isMobileView: false,
                mobileButtonHideShow: true,
                userCheckbox: [],
                permissions: [],
                cantAccessPage: true,
                isRequestComplete: false,
                columns: [
                    /* {
                        label: 'Dayforce Id',
                        field: 'emp_id',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Filter Dayforce Id", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    }, */
                    {
                        label: 'Name',
                        field: 'name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Filter Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Email',
                        field: 'email',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Filter Email", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Is Active',
                        field: 'is_active',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "All", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: ['YES', 'NO'],
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Section',
                        field: 'sectionRoleHtml',
                        filterable: true,
                        html: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Filter Section Or Role", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        field: 'action',
                        sortable: false,
                    },
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    sort: {
                        field: 'id',
                        type: 'desc',
                    },
                    page: 1,
                    perPage: 10
                },
                userArray: [],
                firstLoad: 0,
            }
        },
        watch:{
            //check permission change
            /* permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_user') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_group') {
                            self.group_value = true;
                        }
                    }
                }
            }, */
            /* cantAccessPage: function(cantAccessPage) {
                var self = this;
                alert(cantAccessPage);
                self.cantAccessPage = cantAccessPage;
            } */
            userCheckbox: function (userCheckbox) {
                var self = this;
                self.mobileButtonHideShow = true;
                if (userCheckbox.length > 0) {
                    self.mobileButtonHideShow = false;
                }
            }
        },
        beforeMount: function() {
            contex = this;
        },
        mounted: function() {
            var self = this;
            self.loadUser();
            EventBus.$emit("headerMobileView", 'User List');
            self.isRequestComplete = false;
            // self.getPermissions(self.callback);
            self.getPermissions();

            self.mobileResizeViewUserListPage();
            window.onresize = function() {
                self.mobileResizeViewUserListPage();
            };
        },
        filters: {
            filterUSting(data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            }
        },
        methods: {
            mobileResizeViewUserListPage: function() {
                var self = this;
                if (window.innerWidth < 766) {
                    self.isMobileView = true;
                } else {
                    self.isMobileView = false;
                }
            },
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadUser();
            },
            onPerPageChange(params) {
                this.serverParams.page=1;
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.loadUser();
            },
            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field:('name');
                    field:('email');
                    field:('status');

                };
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                if (this.firstLoad == 1) {
                    this.loadUser();
                }
            },
            selectionChanged() {
                var self = this;
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadUser();
            },
            loadUser: function() {
                var self = this;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    isUserList: 'userList',
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                self.firstLoad = 1;
                self.showLoader();
                HTTP.post("list-user", fields, config)
                    .then(function (response) {
                        if (response.data.code == '200') {
                            if (response.data.content != "") {
                                self.userArray = response.data.content.row;
                                self.rows = response.data.content.row;
                                self.totalRecords = response.data.content.totalRecords;
                                self.filteredFlag = false;
                            }
                        }
                        self.hideLoader();
                    })
                    .catch(function (error) {
                        self.hideLoader();
                        self.catchHandler(error, function () {});
                    });
            },
            activeOrInactiveState(txtValue) {
                var self = this;
                var use = [];
                if(self.isMobileView) {
                    use = self.userCheckbox;
                } else {
                    var data = this.$refs['listUserList'].selectedRows;
                    for (var i = 0; i < data.length; i++) {
                        use.push(this.$refs['listUserList'].selectedRows[i].id)
                    }
                }
                self.$swal({
                    title: '',
                    text: 'Are you sure that you want to '+ txtValue + ' this User!',
                    type: 'info',
                    confirmButtonText: 'OK',
                    showCancelButton: true,
                    // showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {

                        var fields = {
                            id: use,
                            flag: txtValue
                        };
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                        };
                        self.showLoader();
                        HTTP.post("validate-user", fields, config)
                            .then(function (response) {
                                if (response.data.code == '200') {
                                    self.loadUser();
                                    if(self.isMobileView) {
                                        self.userCheckbox = [];
                                        self.mobileButtonHideShow = true;
                                    }
                                    if(response.data.content > 0) {
                                        //alert(response.data.content + " User has been already " + txtValue);
                                    }
                                }
                                self.hideLoader();
                            })
                            .catch(function (error) {
                                self.hideLoader();
                                self.catchHandler(error, function () {});
                            });
                    }
                });
            },
            callback: function(status) {
                var self = this;
                self.isRequestComplete = true;
            }
        }
    }
    EventBus.$on("serachUserArrayData", function(data) {
        contex.userArray = data;
    });
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->


// WEBPACK FOOTER //
// src/components/Users/UserList.vue